import { Theme } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';

const ITEM_HEIGHT = 48;

const commonRootStyles = (theme: Theme) => {
  const {
    custom: {
      palette: { colorSupportSteel },
    },
    palette: {
      action: { active },
      background: { paper },
      text,
    },
    shadows,
    spacing: { unit },
    typography: { fontFamily, pxToRem },
  } = theme;

  return {
    flexGrow: 1,
    '& .Select-multi-value-wrapper': {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'wrap',
      lineHeight: 31,
      minHeight: 46,
      padding: `${unit / 2}px`,
      width: `calc(100% - ${unit * 4}px)`,
    },
    '& .Select--multi .Select-multi-value-wrapper': {
      display: 'flex',
    },
    '& .Select--multi .Select-input': {
      margin: 0,
    },
    '& .Select.has-value.Select--single > .Select-control .Select-value': {
      padding: unit * 2,
    },
    '& .Select.has-value.Select--multi > .Select-control > .Select-multi-value-wrapper > .Select-input > input': {
      padding: 0,
    },
    '& .Select-noresults': {
      padding: unit * 2,
    },
    '& .Select-input': {
      display: 'inline-flex !important',
      height: 'auto',
      paddingLeft: 0,
      paddingRight: 0,
    },
    '&$startAdornment .Select-input': {
      paddingLeft: '22px !important',
    },
    '& .Select-input input': {
      background: 'transparent',
      border: 0,
      color: text.primary,
      fontWeight: 500,
      height: 38,
      lineHeight: 18,
      padding: `0px ${unit + 4}px`,
      cursor: 'default',
      display: 'inline-flex',
      fontFamily: 'inherit',
      fontSize: 'inherit',
      margin: 0,
      outline: 0,
    },
    '& .Select--single > .Select-control .Select-value': {
      padding: 0,
      color: text.primary,
      lineHeight: 1,
      paddingLeft: 0,
      paddingRight: 0,
    },
    '& .Select-placeholder, .Select--single .Select-value': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      fontFamily,
      fontSize: pxToRem(14),
      padding: 16,
    },
    '& .Select-placeholder': {
      color: colorSupportSteel,
      fontWeight: 500,
      lineHeight: 1,
      paddingLeft: 16,
    },
    '&$startAdornment .Select-placeholder': {
      paddingLeft: '38px !important',
    },
    '& .Select-menu-outer': {
      backgroundColor: paper,
      boxShadow: shadows[2],
      position: 'absolute',
      left: 0,
      top: `calc(100% + ${unit}px)`,
      width: '100%',
      zIndex: 2,
      maxHeight: ITEM_HEIGHT * 4.5,
    },
    '& .Select.is-focused:not(.is-open) > .Select-control': {
      boxShadow: 'none',
    },
    '& .Select-menu': {
      maxHeight: ITEM_HEIGHT * 4.5,
      overflowY: 'auto',
    },
    '& .Select-menu div': {
      boxSizing: 'content-box',
      color: text.primary,
    },
    '& .Select-arrow-zone': {
      display: 'table-cell',
      flexDirection: 'column',
      justifyContent: 'center',
      top: 0,
    },
    '& .Select-arrow-zone, .Select-clear-zone': {
      color: active,
      cursor: 'pointer',
      width: 32,
      zIndex: 1,
    },
    '& .Select--multi .Select-clear-zone': {
      width: 32,
    },
    '& .Select-clear-zone': {
      marginRight: 0,
    },
    '& .Select-loading-zone': {
      marginRight: 10,
    },
    '& .Select-loading': {
      width: 22,
      height: 22,
    },
    // Only for screen readers. We can't use display none.
    '& .Select-aria-only': {
      position: 'absolute',
      overflow: 'hidden',
      clip: 'rect(0 0 0 0)',
      height: 1,
      width: 1,
      margin: -1,
    },
    '& .Select-control > *:last-child': {
      paddingRight: 0,
    },
  };
};

const styles = (theme: Theme) => {
  const {
    palette: { text },
  } = theme;

  return {
    label: {
      color: text.primary,
    },
    startAdornment: {},
    root: {
      '& .Select-control': {
        display: 'flex',
        alignItems: 'center',
        border: 0,
        height: 'auto',
        minHeight: 20,
        background: 'transparent !important',
        '&:hover': {
          boxShadow: 'none',
        },
      },
      ...commonRootStyles(theme),
    },
    smallRoot: {
      '& .Select-control': {
        display: 'flex',
        alignItems: 'center',
        border: 0,
        minHeight: 20,
        background: 'transparent !important',
        '&:hover': {
          boxShadow: 'none',
        },
      },
      ...commonRootStyles(theme),
    },
    textFieldInput: {
      padding: 0,
    },
    textFieldUnderline: {
      borderBottom: `1px solid ${grey[300]}`,
    },
    rounded: {
      borderRadius: 5,
    },
    disabled: {
      border: `1px solid ${grey[300]}`,
      '& .Select-placeholder': {
        color: grey[300],
      },
    },
    nullOption: {
      '& .Select-placeholder': {
        color: text.primary,
      },
    },
  };
};

export default styles;
